import React from 'react';
import styled from 'styled-components';
import { Color, Shadow } from '../app/StyleGuide';
import { AgeCategory, BrandCode } from '../features/curriculum';

const banners = {
  BSFL: {
    Preschool: 'img/BSFL-kids-banner.jpg',
    Kids: 'img/BSFL-kids-banner.jpg',
    Students: 'img/BSFL-students-banner.jpg',
    Adult: 'img/BSFL-adult-banner.jpg',
  },
  ETB: {
    Preschool: 'img/ETB-kids-banner.jpg',
    Kids: 'img/ETB-kids-banner.png',
    Students: 'img/ETB-students-banner.png',
    Adult: 'https://assets.lifeway.com/f_auto/MG_Hero_Image_ETB2_Adults',
  },
  TGP: {
    Preschool: 'img/TGP-preschool-banner_v2.jpg',
    Kids: 'img/TGP-kids-banner_v2.jpg',
    Students: 'img/TGP-students-banner_v2.jpg',
    Adult: 'img/TGP-adult-banner_v2.jpg',
  },
  YOU: {
    Preschool: null,
    Kids: null,
    Students: null,
    Adult: 'img/YOU-adult-banner.jpg',
  },
  HYFI: {
    Preschool: 'https://assets.lifeway.com/f_auto/HyfiBannerBackground_GridBanner_Preschool_1',
    Kids: 'https://assets.lifeway.com/f_auto/HyfiBannerBackground_GridBanner_Kids_1',
    Students: 'https://assets.lifeway.com/f_auto/HyfiBannerBackground_GridBanner_Students',
    Adult: null,
  },
  HYFICHRISTMAS: {
    Preschool: 'img/hyfi-christmas-preview/banner.png',
    Kids: 'img/hyfi-christmas-preview/banner.png',
    Students: 'img/hyfi-christmas-preview/banner.png',
    Adult: null,
  },
  VBS: {
    Preschool: 'https://assets.lifeway.com/f_auto/GRID_VBS_PREVEIW_2800x380',
    Kids: 'https://assets.lifeway.com/f_auto/GRID_VBS_PREVEIW_2800x380',
    Students: 'https://assets.lifeway.com/f_auto/GRID_VBS_PREVEIW_2800x380',
    Adult: 'https://assets.lifeway.com/f_auto/GRID_VBS_PREVEIW_2800x380',
  },
} satisfies Record<BrandCode, Record<AgeCategory, string | null>>;

const BannerContainer = styled.div`
  min-height: 190px;
  background: ${Color.Gray._50};
  box-shadow: ${Shadow.small};

  @media print {
    display: none;
  }
`;

const BannerImg = styled.img`
  width: 100%;
  min-height: 190px;
  object-fit: cover;
  margin: 0;
`;

type Props = {
  brandCode: BrandCode;
  ageCategory: AgeCategory;
  altText?: string;
};

export function CurriculumBrandBanner({ brandCode, ageCategory, altText }: Props) {
  const banner = banners[brandCode]?.[ageCategory];
  if (!banner) return null;

  return (
    <BannerContainer>
      <BannerImg src={banner} alt={altText || `${brandCode}: ${ageCategory}`} />
    </BannerContainer>
  );
}
